import { formValueSelector } from 'redux-form';
import { curry } from 'ramda';

export const reduxFormSelector = curry((formId: string, fieldNames: string[], state: any) =>
	formValueSelector(formId)(state, ...fieldNames)
);
